import { makeStyles } from '@mui/styles';
import { WHITE_COLOR } from '../../styles/constants';

export const useStyles = makeStyles({
  actionBox: {
    marginLeft: 'auto',
    display: 'flex',
    columnGap: '0.625rem',
  },
  iconBox: {
    backgroundColor: WHITE_COLOR,
    height: '2.25rem',
    width: '2.188rem',
    alignItems: 'center',
    boxSizing: 'border-box',
    border: '0.125rem solid #F2F2F7',
    borderRadius: '0.625rem',
    boxShadow: '0rem 0.25rem 0.25rem rgb(0 0 0 / 8%), 0px 4px 8px rgb(50 50 71 / 1%)',
  },
  iconStyle: {
    fontSize: '1.188rem',
    marginLeft: '0.125rem',
    // marginTop: "6px",
  },
  sortIconStyle: {
    gap: '2.5rem',
  },
});
